import {
  convertFromSearchOrderDataToSearchOrderRequestArray,
  convertFromSearchOrderRequestToSearchOrderDataArray,
  ISearchOrderData,
  ISearchOrderRequest,
} from './ISearchOrder';
import { IPageData } from 'types/rest/IPageData';

export type ISearchOrderResultRequest = IPageData<ISearchOrderRequest>;

export type ISearchOrderResultData = IPageData<ISearchOrderData>;

export const createDefaultSearchOrderResultData = (): ISearchOrderResultData => ({
  content: [],
  totalElements: 0,
  pageNumber: 0,
  pageSize: 50,
});

export const convertFromSearchOrderResultRequestToSearchOrderResultData = (
  data: ISearchOrderResultRequest
): ISearchOrderResultData => ({
  ...data,
  content: convertFromSearchOrderRequestToSearchOrderDataArray(data.content),
});

export const convertFromSearchOrderResultDataToSearchOrderResultRequest = (
  data: ISearchOrderResultData
): ISearchOrderResultRequest => ({
  ...data,
  content: convertFromSearchOrderDataToSearchOrderRequestArray(data.content),
});
